import React, { useCallback } from 'react';
import { useReactiveVar } from '@apollo/client';

import { sortingTypeExt } from '../../../../../graphql/ecp-locator/ecp-locator.cache';
import { ToggleButtonGroup } from '../../../../common/toggle-button-group';
import { useSortButtons } from './sort-buttons/use-sort-buttons';
import { SortingTypes } from './ecp-sort.models';

export const EcpSort = (): JSX.Element => {
  const currentSortingType = useReactiveVar(sortingTypeExt);
  const buttons = useSortButtons();

  const handleSort = useCallback((): void => {
    sortingTypeExt(currentSortingType === SortingTypes.distance ? SortingTypes.rating : SortingTypes.distance);
  }, [sortingTypeExt, currentSortingType]);

  return (
    <ToggleButtonGroup
      fullWidth
      exclusiveExactly
      withoutMargins
      size="small"
      variant="outlined"
      options={buttons}
      value={currentSortingType}
      onChange={handleSort}
      exclusive
    />
  );
};
